import controller from './orderAndPick.controller';
import template from './orderAndPick.html';

const OrderAndPickDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default OrderAndPickDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPick/orderAndPick.component.js
 **/